import { render, staticRenderFns } from "./AppointmentReportSummary.vue?vue&type=template&id=5b1a94e8&scoped=true&"
import script from "./AppointmentReportSummary.vue?vue&type=script&lang=js&"
export * from "./AppointmentReportSummary.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentReportSummary.vue?vue&type=style&index=0&id=5b1a94e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a94e8",
  null
  
)

export default component.exports